define.alias("shared/utils/formatters/ig-story-from-dynamo", "preview-grid/utils/formatters/ig-story-from-dynamo");